import React from "react";
import styles from './Footer.module.css';
import { NavLink } from "react-router-dom";
import { ReactComponent as Help } from './../imgs/icons/help.svg';

export default function FooterExternal(){

    const handleNavClick = () => {
        window.scrollTo(0,0);
    }

    return (
        <footer className={styles.external}>
            <div className={styles.helpCon}>
                <div className={styles.helpIcon}>
                    <Help />
                </div>
                <p>For any help or assistance,</p>
                <p>please reach out to:</p>
            </div>
            <div className={styles.footerFooter}>
                <div className={styles.contact}>info@goodyear-retail-brand-hub.com</div>
                <div className={styles.links}>
                    <NavLink to="/login" onClick={handleNavClick}>Login</NavLink>
                    <NavLink to="/register" onClick={handleNavClick}>Register</NavLink>
                    <NavLink to="/cookiePolicy" onClick={handleNavClick}>Cookie Policy</NavLink>
                    <NavLink to="/privacyPolicy" onClick={handleNavClick}>Privacy Policy</NavLink>
                    <NavLink to="/privacyPolicyJotform" onClick={handleNavClick}>Privacy Policy (Jotform)</NavLink>
                </div>
                <div className={styles.copyright}>© Stratela Ltd 2026</div>
            </div>
        </footer>
    )
}